<template>
  <div v-if="isLoading" class="flex items-center justify-center px-16">
    <JIcon name="spinner" size="40" />
  </div>

  <MyInterestsAndActivitiesFormFields
    v-else
    :interestsAndActivities="interestsAndActivities"
    :userInterestsAndActivities="userInterestsAndActivities"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { JIcon } from '@journey/ui-kit'
import MyInterestsAndActivitiesFormFields from './MyInterestsAndActivitiesFormFields/MyInterestsAndActivitiesFormFields.vue'
import {
  useInterestsAndActivities,
  useUserInterestsAndActivities,
} from '@/modules/Profile/requests/queries'

// DATA
const { data, isLoading: loadingList } = useInterestsAndActivities()
const { data: userData, isLoading: loadingUserData } =
  useUserInterestsAndActivities()

const interestsAndActivities = computed(() => data.value?.data ?? [])
const userInterestsAndActivities = computed(() => userData.value?.data ?? [])

// LOADING
const isLoading = computed(() => loadingList.value || loadingUserData.value)
</script>
